import { render, staticRenderFns } from "./IgmpSnoopGlobal.vue?vue&type=template&id=4fbbbff2&"
import script from "./IgmpSnoopGlobal.vue?vue&type=script&lang=js&"
export * from "./IgmpSnoopGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports